import React from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import "./App.css";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import Solutions from "./pages/Solutions";
import Municipality from "./pages/solutions/Municipality";
import IndustrialZone from "./pages/solutions/IndustrialZone";
import ElectronicDocument from "./pages/solutions/ElectronicDocument";
import FinanceRevenue from "./pages/solutions/FinanceRevenue";
import FieldInfrastructure from "./pages/solutions/FieldInfrastructure";
import PortalsIntegrations from "./pages/solutions/PortalsIntegrations";
import StructuredInstitutions from "./pages/solutions/StructuredInstitutions";
import ProductPortfolio from "./pages/ProductPortfolio";
import Technology from "./pages/Technology";
import Implementation from "./pages/Implementation";
import Markets from "./pages/Markets";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Sitemap from "./pages/Sitemap";
import LegalCenter from "./pages/LegalCenter";

import Privacy from "./pages/legal/Privacy";
import CookiePolicy from "./pages/legal/CookiePolicy";
import Terms from "./pages/legal/Terms";
import Disclaimer from "./pages/legal/Disclaimer";
import CompanyInformation from "./pages/legal/CompanyInformation";
import Security from "./pages/legal/Security";
import Accessibility from "./pages/legal/Accessibility";

const NotFound = () => (
  <main data-testid="page-not-found" className="bg-white">
    <div className="max-w-3xl mx-auto px-6 py-32 text-center">
      <div className="tag-overline">404 · Not Found</div>
      <h1 className="heading-display mt-4 text-4xl sm:text-5xl font-semibold">
        This page does not exist.
      </h1>
      <p className="mt-5 text-ink-600">
        The page you’re looking for may have moved or never existed in this version of the
        Allinstra website.
      </p>
      <div className="mt-8 flex justify-center gap-3">
        <Link to="/" className="btn-primary">Return Home</Link>
        <Link to="/sitemap" className="btn-secondary">View Sitemap</Link>
      </div>
    </div>
  </main>
);

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-white text-ink-900">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/solutions/municipality" element={<Municipality />} />
            <Route path="/solutions/industrial-zone" element={<IndustrialZone />} />
            <Route path="/solutions/electronic-document" element={<ElectronicDocument />} />
            <Route path="/solutions/finance-revenue" element={<FinanceRevenue />} />
            <Route path="/solutions/field-infrastructure" element={<FieldInfrastructure />} />
            <Route path="/solutions/portals-integrations" element={<PortalsIntegrations />} />
            <Route path="/solutions/structured-institutions" element={<StructuredInstitutions />} />
            <Route path="/product-portfolio" element={<ProductPortfolio />} />
            <Route path="/technology" element={<Technology />} />
            <Route path="/implementation" element={<Implementation />} />
            <Route path="/markets" element={<Markets />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/sitemap" element={<Sitemap />} />
            <Route path="/legal-center" element={<LegalCenter />} />
            <Route path="/legal" element={<LegalCenter />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/company-information" element={<CompanyInformation />} />
            <Route path="/imprint" element={<CompanyInformation />} />
            <Route path="/security" element={<Security />} />
            <Route path="/accessibility" element={<Accessibility />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <Footer />
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
